import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGoldenStandardOfFreshness from "./sections/TheGoldenStandardOfFreshness";
import ValuesMission from "./sections/ValuesMission";
import WhatWeDo from "./sections/WhatWeDo";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGoldenStandardOfFreshness />
      <WhatWeDo />
      <ValuesMission />
      <FinalCallToAction />
      <Footer />
    </div>;
}